import { tok, tokPx } from '@sunwebgroup/ui-components'
import { styled } from 'styled-components'

export const Card = styled.div`
  background-color: ${tok('semantics_views_background_color')};
  border-radius: ${tokPx('semantics_cards_corner_radius')};
  overflow: hidden;
  box-shadow: ${tok('primitives_box_shadows_level_2')};
`
